const HOME = '/'
const SERVICE = '/dental-services'
const CLINIC = '/our-clinic'
const STERILIZATION = '/sterilization'
const OURTEAM = '/our-team'
const EGYPT = '/why-egypt'
const CONTACT = '/contact-us'
const BLOG = '/blog'
const DENTALSERVICE = `${SERVICE}/dental-diagnoses-and-gp`;
const AESTHETICSDENTISTRY = `${SERVICE}/aesthetics-dentistry`;
const ENDODONTICDENTISTRY = `${SERVICE}/endodontic-dentistry`;
const ORALSURGERY = `${SERVICE}/oral-surgery`;
const ORTHODONTICDENTISTRY = `${SERVICE}/orthodontic-dentistry`;
const PROSTHODONTICDENTISTRY = `${SERVICE}/prosthodontic-dentistry`;
const PERIODONTALDENTISTRY = `${SERVICE}/periodontal-dentistry`;
const DENTALIMPLANTS = `${SERVICE}/dental-implants`;
const PEDODONTICDENTISTRY = `${SERVICE}/pedodontic-dentistry`;
const CONTENTFORM = '/content-form'
const SERVICEFORM = `/service-form`
const DOCTORFORM = `/doctor-form` 
const DOCTOR_ROOM = `/doctor-Room`
const CLANIC_PROFILE = `/clanic-profile`
const CONTACT_DATA = `/contact-data`
// second design
const SECONDDESIGN = '/second-design'
const SECONDHOME = `${SECONDDESIGN}`
const ABOUT = `${SECONDDESIGN}/about`
const PROCEDURE = `${SECONDDESIGN}/procedure`
const PROCEDUREDENTISTRY = `${PROCEDURE}/dentistry`
const PROCEDUREDENTALFILLING = `${PROCEDURE}/dental-filling`
const PROCEDUREDENTALBRIDGES = `${PROCEDURE}/dental-bridges`
const PROCEDUREVENEERS = `${PROCEDURE}/veneers`
const PROCEDUREINVISALIGN = `${PROCEDURE}/invisalign`
const PROCEDURECROWNS = `${PROCEDURE}/crowns`
const SECONDABOUT = `${SECONDDESIGN}/about-page-2`
const DENTALSTORE = `${SECONDDESIGN}/shop`
const SHOP = `${SECONDDESIGN}/shop-page-2`
const BEFOREAFTER = `${SECONDDESIGN}/before-after`
const SECONDSERVICE = `${SECONDDESIGN}/service`
const PORTFOLIO = `${SECONDDESIGN}/portfolio`
const PORTFOLIOCARD1 = `${PORTFOLIO}/cras-tristique-purus-non-lacus`
const PORTFOLIOCARD2 = `${PORTFOLIO}/duis-fermentum-felis`
const PORTFOLIOCARD3 = `${PORTFOLIO}/quisque-id-maximus-leo`
const PORTFOLIOCARD4 = `${PORTFOLIO}/proin-venenatis-felis`
const PORTFOLIOCARD5 = `${PORTFOLIO}/aenean-vitae-enim-rhoncus`
const PORTFOLIOCARD6 = `${PORTFOLIO}/donec-in-maximus-augue`
const PORTFOLIOCARD7 = `${PORTFOLIO}/vestibulum-pellentesque-metus`
const PORTFOLIOCARD8 = `${PORTFOLIO}/nulla-rhoncus-efficitur-augue`
const PORTFOLIOCARD9 = `${PORTFOLIO}/aliquam-ut-dictum-sapien`
const PORTFOLIOCARD10 = `${PORTFOLIO}/mauris-nec-nunc-neque`
const PORTFOLIOCARD11 = `${PORTFOLIO}/fusce-at-semper-tellus`
const PORTFOLIOCARD12 = `${PORTFOLIO}/suspendisse-tempor-iaculis-leo`
const APPOINTMENT = `${SECONDDESIGN}/appointment`
const SECONDDESIGNCONTENTFORM = `${SECONDDESIGN}/content-form`
const SECONDDESIGNSERVICEFORM = `${SECONDDESIGN}/service-form`
const SECONDDESIGNDOCTORFORM = `${SECONDDESIGN}/doctor-form`

// third design
const THIRDDESIGN = '/third-design'
const THIRDHOME = `${THIRDDESIGN}`
const THIRDABOUT = `${THIRDDESIGN}/about-us`
const THIRDSERVICE = `${THIRDDESIGN}/service`
const THIRDAPPOINTMENT = `${THIRDDESIGN}/appointment`
const THIRDOURTEAM = `${THIRDDESIGN}/our-team`
const THIRDOURFAQS = `${THIRDDESIGN}/faqs`
const THIRDOURCONTACT = `${THIRDDESIGN}/contact`
const THIRDDESIGNCONTENTFORM = `${THIRDDESIGN}/content-form`

// fourth design
const FOURTHDESIGN = '/fourth-design'
const FOURHTHOME = `${FOURTHDESIGN}`
const FOURHTABOUT = `${FOURTHDESIGN}/about-us`
const FOURHTSERVICE = `${FOURTHDESIGN}/service`
const FOURHTDOCTORS = `${FOURTHDESIGN}/our-team`
const FOURHTCONTACT = `${FOURTHDESIGN}/contact`
const FOURHTCONTENTFORM = `${FOURTHDESIGN}/content-form`

// fourth design
const FIFTHDESIGN = '/fifth-design'
const FIFHTHOME = `${FIFTHDESIGN}`
const FIFHTABOUT = `${FIFTHDESIGN}/about-us`
const FIFHTSPECIALITIES = `${FIFTHDESIGN}/your-health-our-specialities`
const FIFHTEXPERTIES = `${FIFTHDESIGN}/our-centres-of-expertise`
const FIFHTLATESTNEWS = `${FIFTHDESIGN}/latest-news`
const FIFHTCONTACT = `${FIFTHDESIGN}/contact-us`
const FIFHTAPPOINTMENT = `${FIFTHDESIGN}/make-an-appointment`
const FIFHTWHOWEARE = `${FIFTHDESIGN}/who-we-are`
const FIFHTMISSIONANDVISION = `${FIFTHDESIGN}/our-mission-vision`
const FIFHTCOREVALUES = `${FIFTHDESIGN}/our-core-values`
const FIFHTTESTIMONIALS = `${FIFTHDESIGN}/client-testimonials`
const FIFHTCAREERS = `${FIFTHDESIGN}/careers`
const FIFHTOURTEAMS = `${FIFTHDESIGN}/our-team`
const FIFHTOURTPHYSIOTHERAPYORTHOPEDIC = `${FIFTHDESIGN}/physiotherapy-orthopedic`
const FIFHTOURTREHABILITATION = `${FIFTHDESIGN}/rehabilitation`
const FIFHTNEUROLOGYCENTRE = `${FIFTHDESIGN}/neurology-centre-of-expertise`
const FIFHTPEDIATRIC = `${FIFTHDESIGN}/pediatric-rehabilitation-program`
const FIFHTCENTREEXPERTIES = `${FIFTHDESIGN}/back-centre-of-expertise`
const FIFHTFOOTLAB = `${FIFTHDESIGN}/foot-lab-gait-analysis-centre-of-expertise`
const FIFHTKNEECENTREOFEXPERTISE = `${FIFTHDESIGN}/knee-centre-of-expertise`
const FIFHTCONTENTFORM = `${FIFTHDESIGN}/content-form`
const LOGIN = `/login`
const DOCTOR = `/doctor`
const DOCTOR_LOGIN = `${DOCTOR}-login`
const DOCTOR_PROFILE = `${DOCTOR}-profile`
const DOCTOR_CALANDER = `${DOCTOR}-calendar`

export default {
    HOME,
    SERVICE,
    CLINIC,
    STERILIZATION,
    OURTEAM,
    EGYPT,
    CONTACT,
    BLOG,
    DENTALSERVICE,
    AESTHETICSDENTISTRY,
    ENDODONTICDENTISTRY,
    ORALSURGERY,
    ORTHODONTICDENTISTRY,
    PROSTHODONTICDENTISTRY,
    PERIODONTALDENTISTRY,
    DENTALIMPLANTS,
    PEDODONTICDENTISTRY,
    CONTENTFORM,
    SECONDHOME,
    SECONDSERVICE,
    PROCEDURE,
    SECONDABOUT,
    ABOUT,
    BEFOREAFTER,
    PORTFOLIO,
    APPOINTMENT,
    DENTALSTORE,
    SHOP,
    PROCEDUREDENTISTRY,
    PROCEDUREDENTALFILLING,
    PROCEDUREDENTALBRIDGES,
    PROCEDUREVENEERS,
    PROCEDUREINVISALIGN,
    PROCEDURECROWNS,
    PORTFOLIOCARD1,
    PORTFOLIOCARD2,
    PORTFOLIOCARD3,
    PORTFOLIOCARD4,
    PORTFOLIOCARD5,
    PORTFOLIOCARD6,
    PORTFOLIOCARD7,
    PORTFOLIOCARD8,
    PORTFOLIOCARD9,
    PORTFOLIOCARD10,
    PORTFOLIOCARD11,
    PORTFOLIOCARD12,
    SECONDDESIGNCONTENTFORM,
    SECONDDESIGNSERVICEFORM,
    SECONDDESIGNDOCTORFORM,
    THIRDHOME,
    THIRDABOUT,
    THIRDSERVICE,
    THIRDAPPOINTMENT,
    THIRDOURTEAM,
    THIRDOURFAQS,
    THIRDOURCONTACT,
    THIRDDESIGNCONTENTFORM,
    FOURTHDESIGN,
    FOURHTHOME,
    FOURHTABOUT,
    FOURHTSERVICE,
    FOURHTDOCTORS,
    FOURHTCONTACT,
    FOURHTCONTENTFORM,
    FIFHTHOME,
    FIFHTABOUT,
    FIFHTSPECIALITIES,
    FIFHTEXPERTIES,
    FIFHTLATESTNEWS,
    FIFHTCONTACT,
    FIFHTAPPOINTMENT,
    FIFHTWHOWEARE,
    FIFHTMISSIONANDVISION,
    FIFHTCOREVALUES,
    FIFHTTESTIMONIALS,
    FIFHTCAREERS,
    FIFHTOURTEAMS,
    FIFHTOURTPHYSIOTHERAPYORTHOPEDIC,
    FIFHTOURTREHABILITATION,
    FIFHTNEUROLOGYCENTRE,
    FIFHTPEDIATRIC,
    FIFHTCENTREEXPERTIES,
    FIFHTFOOTLAB,
    FIFHTKNEECENTREOFEXPERTISE,
    FIFHTCONTENTFORM,
    SERVICEFORM,
    DOCTORFORM,
    DOCTOR_ROOM,
    LOGIN,
    DOCTOR_LOGIN,
    CLANIC_PROFILE,
    DOCTOR_PROFILE,
    DOCTOR_CALANDER,
    CONTACT_DATA
}